import { render, staticRenderFns } from "./ColSelector.vue?vue&type=template&id=2948bba4&"
import script from "./ColSelector.vue?vue&type=script&lang=js&"
export * from "./ColSelector.vue?vue&type=script&lang=js&"
import style0 from "./ColSelector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports